module.exports = __webpack_public_path__ + "img/Recurso 3.ff8371ab.png";